import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { announcements as announcementsApi } from 'redux/modules/api'

function decorator() {
  return ComposedComponent => {
    @connect(({ api }) => ({
      announcements: api.announcements
    }), { ...announcementsApi })

    class Announcements extends Component {
      static propTypes = {
        announcements: PropTypes.object,
        getCurrentAnnouncement: PropTypes.func
      }

      componentDidMount() {
        const { announcements, getCurrentAnnouncement } = this.props

        !(announcements.loading || announcements.loaded) && getCurrentAnnouncement()
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
          />
        )
      }
    }
    return Announcements
  }
}

export default decorator

